import React from "react";
import AppModal from "./AppModal";

const AddLeadModal = ({ show, setShow }) => {
  return (
    <>
      <AppModal
        show={show}
        setShow={setShow}
        title="Add New Lead"
        size="modal-lg"
        footer={
          <>
            <button className="btn btn-danger" onClick={() => setShow(false)}>
              Close
            </button>

            <button className="btn btn-primary">Save Lead</button>
          </>
        }
      >
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label">Status</label>
            <select className="form-select">
              <option>Select Status</option>
              <option>New</option>
              <option>Hot</option>
              <option>Cold</option>
            </select>
          </div>

          {/* Source */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Source</label>
            <select className="form-select">
              <option>Select Source</option>
              <option>Facebook</option>
              <option>Google</option>
              <option>Instagram</option>
              <option>Website</option>
            </select>
          </div>

          {/* Assign User */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Assign User</label>
            <select className="form-select">
              <option>Select User</option>
              <option>Amit</option>
              <option>Rahul</option>
              <option>Sonia</option>
            </select>
          </div>

          {/* Customer Name */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Customer Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter customer name"
            />
          </div>

          {/* Mobile Number */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Mobile Number</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter mobile number"
              name="mobile"
            />
          </div>

          {/* Email */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter email address"
            />
          </div>

          {/* Company Name */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Company Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter company name"
            />
          </div>

          {/* Follow Up Date */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Follow-Up Date</label>
            <input type="date" className="form-control" />
          </div>

          {/* Estimate Amount */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Estimate Amount</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter estimate amount"
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
              }}
            />
          </div>

          {/* Reference */}
          <div className="col-md-6 mb-3">
            <label className="form-label">Reference</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter reference"
            />
          </div>

          {/* Address */}
          <div className="col-md-12 mb-3">
            <label className="form-label">Address</label>
            <textarea
              rows="4"
              className="form-control"
              placeholder="Write Address here..."
            ></textarea>
          </div>

          {/* Comment */}
          <div className="col-md-12 mb-3">
            <label className="form-label">Comment</label>
            <textarea
              rows="4"
              className="form-control"
              placeholder="Write comment here..."
            ></textarea>
          </div>
        </div>
      </AppModal>
    </>
  );
};

export default AddLeadModal;
